import React from 'react';
import '../styles/userFeedback.css';

const UserFeedback = () => {
  // Demo feedback data - 50 feedbacks
  const feedbacks = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Software Engineer at Google",
      feedback:
        "I just took your quiz. I liked that you are incorporating variety of topics which makes it fun and also made me think about comparing the different data structures. The level of questions was increasing which is also good. And the code snippets was a nice addition.",
      rating: 5,
      avatar: "SC",
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Full Stack Developer",
      feedback:
        "Overall the quiz was fun. I took it on my phone. I liked the fact that I can take the quiz on the go. So it is less intense then solving leetcode which is a nice. I think of it as a good dopamine boost.",
      rating: 5,
      avatar: "MR",
    },
    {
      id: 3,
      name: "Priya Patel",
      role: "CS Student at MIT",
      feedback:
        "The email format makes it so easy to stay consistent. I never miss a day now thanks to PrepLetter's scheduling.",
      rating: 5,
      avatar: "PP",
    },
    {
      id: 4,
      name: "David Kim",
      role: "Senior SDE at Amazon",
      feedback: "Love this initiative. Thanks for this. ❤️",
      rating: 5,
      avatar: "DK",
    },
    {
      id: 5,
      name: "Varun",
      role: "Backend Engineer",
      feedback:
        "I loved the quiz feature, 10/10 😉 It was very fun, accessible and the options were good , not some random options which are easily overlooked. Can’t wait for the next ones !! Great work 🙌🏻🥳",
      rating: 5,
      avatar: "ET",
    },
    {
      id: 6,
      name: "Alex Johnson",
      role: "DevOps Engineer",
      feedback:
        "Love the bite-sized format. Perfect for my morning coffee routine. Makes DSA practice actually enjoyable!",
      rating: 5,
      avatar: "AJ",
    },
    {
      id: 7,
      name: "Lisa Wang",
      role: "Product Engineer at Stripe",
      feedback:
        "It truly feels like a love letter to people who genuinely want to get into Leetcode.",
      rating: 5,
      avatar: "LW",
    },
    {
      id: 8,
      name: "James Wilson",
      role: "Frontend Developer",
      feedback:
        "I feel significant improvement in my DSA journey with PrepLetter. You guys are doing a great job!",
      rating: 5,
      avatar: "JW",
    },
    {
      id: 9,
      name: "Sophia Martinez",
      role: "Mobile Developer",
      feedback:
        "The personalized timing is perfect. I read the letters Daily, Getting PrepLetters at 9 AM fits perfectly with my learning schedule. At my 11th Article now, loved the milestone quiz btw!",
      rating: 5,
      avatar: "SM",
    },
    {
      id: 10,
      name: "Ryan O'Connor",
      role: "Platform Engineer",
      feedback:
        "It's a very good initiative . People who are learning DSA alongside their job or other commitment it's a very good platform to learn. I am very new in this platform . May be later I  will give better, precise feedback.",
      rating: 5,
      avatar: "RO",
    },
    {
      id: 11,
      name: "Zara Ahmed",
      role: "Data Engineer at Netflix",
      feedback: "10 on 10! Super helpful",
      rating: 5,
      avatar: "ZA",
    },
    {
      id: 12,
      name: "Michael Brown",
      role: "Security Engineer",
      feedback:
        "i stopped leetcode as understanding the patterns was too hard for me, now prepletter is super helpful to see the patterns and understand the logic",
      rating: 5,
      avatar: "MB",
    },
    {
      id: 13,
      name: "Ava Davis",
      role: "AI/ML Engineer",
      feedback: "It's helping me to solve problems every day.",
      rating: 5,
      avatar: "AD",
    },
    {
      id: 14,
      name: "Carlos Vega",
      role: "Site Reliability Engineer",
      feedback: "I really like the Pattern wise problems and solutions.",
      rating: 5,
      avatar: "CV",
    },
    {
      id: 15,
      name: "Maya Singh",
      role: "Cloud Engineer",
      feedback:
        "I'm a senior SRE at Google, I found it's really great to keep in touch with DSA, I requested a feature to let me schedule when I want to receive it and how often, they literally made it possible from the next day!",
      rating: 5,
      avatar: "MS",
    },
    {
      id: 16,
      name: "Tom Anderson",
      role: "Principal Engineer",
      feedback:
        "I love how it gives me random problems which I wouldn't be solving because I wouldn't be able to find it normally unless i tried.",
      rating: 5,
      avatar: "TA",
    },
    {
      id: 17,
      name: "Isabella Garcia",
      role: "Fullstack Engineer at Uber",
      feedback: "Great job guys. Hats off! I already love how easily these are explained and similar problems are connected together",
      rating: 5,
      avatar: "IG",
    },
    {
      id: 18,
      name: "Kevin Liu",
      role: "Software Architect",
      feedback:
        "The quality is consistently excellent. Every problem teaches something valuable.",
      rating: 5,
      avatar: "KL",
    }
  ];

  // Split feedbacks into rows for news bulletin style
  const getRowFeedbacks = (rowIndex) => {
    const rowStart = rowIndex * Math.ceil(feedbacks.length / 4);
    const rowEnd = Math.min(rowStart + Math.ceil(feedbacks.length / 4), feedbacks.length);
    return feedbacks.slice(rowStart, rowEnd);
  };

  // Create 4 rows of feedbacks
  const rows = [0, 1, 2, 3].map(rowIndex => getRowFeedbacks(rowIndex));

  // Duplicate feedbacks for seamless loop
  const createInfiniteRow = (rowFeedbacks) => {
    return [...rowFeedbacks, ...rowFeedbacks, ...rowFeedbacks];
  };

  return (
    <section className="user-feedback-section" id="feedback">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">What Our Users Say</h2>
          <p className="section-subtitle">
            Join thousands of developers who've transformed their coding skills with PrepLetter
          </p>
        </div>

        <div className="feedback-bulletin-container">
          {rows.map((rowFeedbacks, rowIndex) => (
            <div key={rowIndex} className={`feedback-row row-${rowIndex}`}>
              <div className="feedback-track">
                {createInfiniteRow(rowFeedbacks).map((feedback, index) => (
                  <div key={`${feedback.id}-${index}`} className="user-feedback-card">
                    <div className="user-feedback-content">
                      <p className="user-feedback-text">"{feedback.feedback}"</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UserFeedback;
